module.exports = __webpack_public_path__ + "static/media/factory.1f2b43ec.svg";